import { css } from '@emotion/react';

import * as React from 'react';

import { Grid, Pagination } from '@coursera/cds-core';

import SearchBar from 'bundles/admin-v2/components/SearchBar';

import _t from 'i18n!nls/staff-management';

import { PAGE_SIZE } from '../constants';
import AdminUserRolesTable from './AdminUserRolesTable';
import { useAdminUserRolesData } from './StaffPermissionsData/AdminUserRolesData';

const styles = {
  paginatorContainer: () => css`
    margin-top: var(--cds-spacing-200);
  `,
  // empirical value based on the height of thead and tr
  tableContainer: css`
    min-height: 530px;
  `,
  searchBar: css`
    max-width: 40%;
  `,
};

const UserTableView = () => {
  const { totalCount, pageNumber, handlePaginationPageChange, handleSearchQueryChange } = useAdminUserRolesData();

  return (
    <React.Fragment>
      <SearchBar
        onQueryChange={handleSearchQueryChange}
        additionalStyles={styles.searchBar}
        /* eslint-disable-next-line no-restricted-syntax */
        placeholderText={_t('Search for a program, course, or session')}
      />
      <Grid css={styles.tableContainer}>
        <AdminUserRolesTable />
      </Grid>
      <Grid container justifyContent="center" css={styles.paginatorContainer}>
        <Pagination
          // as discussed, the pagesize control is not displayed, thus the page size is a constant
          hidePageSizeInput={true}
          page={pageNumber}
          defaultPageSize={PAGE_SIZE}
          total={totalCount}
          onPageChange={handlePaginationPageChange}
        />
      </Grid>
    </React.Fragment>
  );
};

export default UserTableView;
